import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { blue, lightBlue } from '@mui/material/colors';
import { Box } from '@mui/system';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import SystemUtil from '@/util/SystemUtil';
import ReactComponent from './ReactComponent';
import { TIPO_TEXTO } from './certidao/AlertaInconsistenciaEmentaDecisao';

class ComparadorEmentaDecisao extends ReactComponent {
    anchorElDecisao = null;
    anchorElEmenta = null;
    openMenuDecisao = false;
    openMenuEmenta = false;
    desconsiderarQuebrasLinhasEmenta = false;
    desconsiderarQuebrasLinhasDecisao = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            anchorElDecisao: observable,
            anchorElEmenta: observable,
            openMenuDecisao: observable,
            openMenuEmenta: observable,
            desconsiderarQuebrasLinhasEmenta: observable,
            desconsiderarQuebrasLinhasDecisao: observable,
            handleClickMenuDecisao: action,
            handleClickMenuEmenta: action,
            handleClickDesconsiderarQuebraLinhasEmenta: action,
            handleClickDesconsiderarQuebraLinhasDecisao: action,
            handleCloseMenuDecisao: action,
            handleCloseMenuEmenta: action,
            registro: computed,
            textoDecisaoVoto: computed,
            textoEmentaVoto: computed,
            textoDecisao: computed,
            textoEmenta: computed,
            handleClickCopiarTextoDecisao: action,
            handleClickCopiarTextoEmenta: action,
            renderMenuDecisao: computed,
            renderMenuEmenta: computed
        });
    }

    handleClickMenuDecisao = (event) => {
        this.anchorElDecisao = event.currentTarget;
        this.openMenuDecisao = true;
    };

    handleClickMenuEmenta = (event) => {
        this.anchorElEmenta = event.currentTarget;
        this.openMenuEmenta = true;
    };

    handleClickDesconsiderarQuebraLinhasEmenta = () => {
        this.desconsiderarQuebrasLinhasEmenta = !this.desconsiderarQuebrasLinhasEmenta;
        this.handleCloseMenuEmenta();
    };

    handleClickDesconsiderarQuebraLinhasDecisao = () => {
        this.desconsiderarQuebrasLinhasDecisao = !this.desconsiderarQuebrasLinhasDecisao;
        this.handleCloseMenuDecisao();
    };

    handleCloseMenuDecisao = () => {
        this.anchorElDecisao = null;
        this.openMenuDecisao = false;
    };

    handleCloseMenuEmenta = () => {
        this.anchorElEmenta = null;
        this.openMenuEmenta = false;
    };

    get registro() {
        return this.observableProps.registro;
    }

    get textoDecisaoVoto() {
        return this.desconsiderarQuebrasLinhasDecisao
            ? this.removerQuebrasDeLinha(this.registro.ementaDecisaoVoto.decisao)
            : this.registro.ementaDecisaoVoto.decisao;
    }

    get textoEmentaVoto() {
        return this.desconsiderarQuebrasLinhasEmenta
            ? this.removerQuebrasDeLinha(this.registro.ementaDecisaoVoto.ementa)
            : this.registro.ementaDecisaoVoto.ementa;
    }

    get textoDecisao() {
        return this.desconsiderarQuebrasLinhasDecisao
            ? this.removerQuebrasDeLinha(this.registro.decisao)
            : this.registro.decisao;
    }

    get textoEmenta() {
        return this.desconsiderarQuebrasLinhasEmenta
            ? this.removerQuebrasDeLinha(this.registro.ementa)
            : this.registro.ementa;
    }

    removerQuebrasDeLinha(texto) {
        return texto.replace(/(?:\r\n|\r|\n|<br>|<br\/>|<br \/>)/g, ' ');
    }

    handleClickCopiarTextoDecisao = (texto) => {
        this.copiarTexto(texto, 'decisão');
        this.handleCloseMenuDecisao();
    };

    handleClickCopiarTextoEmenta = (texto) => {
        this.copiarTexto(texto, 'ementa');
        this.handleCloseMenuEmenta();
    };

    copiarTexto(texto, descricaoTipoTexto) {
        if (!SystemUtil.copiarParaAreaDeTransferencia(texto)) {
            this.mensagemStore.abrirMensagemAlerta(
                `Falha na tentativa de copiar o conteúdo da ${descricaoTipoTexto} para a área de transferência. Tente copiar o texto manualmente.`
            );
        }
    }

    formatHTMLForDiff(htmlStr, textOnly) {
        const formattedHTML = htmlStr; // TODO Verificar se é necessário algum tratamento

        if (textOnly) {
            return new DOMParser().parseFromString(formattedHTML, 'text/html').body.innerText;
        }

        return formattedHTML;
    }

    renderDialogContent() {
        if (
            !this.isComponenteHabilitado('PlanilhaPlenario') ||
            !this.registro ||
            !this.registro.ementaDecisaoVoto ||
            (!this.observableProps.exibirComparacaoDecisao && !this.observableProps.exibirComparacaoEmenta)
        ) {
            return <></>;
        }

        return (
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    width: '100%',
                    maxWidth: 'lg',
                    '& > :not(style)': {
                        m: 1
                    }
                }}
            >
                {this.observableProps.exibirComparacaoDecisao &&
                    this.renderComponenteComparacao(TIPO_TEXTO.DECISAO, this.textoDecisaoVoto, this.textoDecisao)}
                {this.observableProps.exibirComparacaoEmenta &&
                    this.renderComponenteComparacao(TIPO_TEXTO.EMENTA, this.textoEmentaVoto, this.textoEmenta)}
                {this.observableProps.exibirAnotacaoGabinete && this.renderAnotacaoGabinete()}
            </Box>
        );
    }

    renderAnotacaoGabinete() {
        const titulo = 'Observação do Gabinete';

        return (
            <Card
                variant="outlined"
                sx={{ width: '100%', overflow: 'auto' }}
            >
                <CardHeader
                    avatar={this.renderAvatar('label-observacao-gabinete', titulo)}
                    title={this.renderTituloTexto(titulo)}
                ></CardHeader>
                <CardContent>{this.registro.observacaoGabinete}</CardContent>
            </Card>
        );
    }

    renderAvatar(ariaLabel, titulo) {
        return (
            <Avatar
                sx={{ bgcolor: blue[900] }}
                aria-label={ariaLabel}
            >
                {titulo.charAt(0)}
            </Avatar>
        );
    }

    renderTituloTexto(titulo) {
        return (
            <Typography
                fontSize={14}
                sx={{ fontWeight: 'bold' }}
            >
                {titulo}
            </Typography>
        );
    }

    renderComponenteComparacao(tipoTexto, conteudoAntigo, conteudoNovo) {
        const titulo = tipoTexto.descricao;

        return (
            <Card
                variant="outlined"
                sx={{ width: '100%', overflow: 'auto' }}
            >
                <CardHeader
                    avatar={this.renderAvatar('label-'.concat(titulo), titulo)}
                    action={tipoTexto.id === TIPO_TEXTO.DECISAO.id ? this.renderMenuDecisao : this.renderMenuEmenta}
                    title={this.renderTituloTexto(titulo)}
                ></CardHeader>
                <CardContent>{this.renderComparador(conteudoAntigo, conteudoNovo)}</CardContent>
            </Card>
        );
    }

    get renderMenuDecisao() {
        const tipoTexto = TIPO_TEXTO.DECISAO;
        const ariaLabel = 'configuracoes-'.concat(tipoTexto.id);
        const ariaControls = 'menu-'.concat(tipoTexto.id);
        const buttonIconId = 'button-'.concat(tipoTexto.id);

        return (
            <>
                <IconButton
                    aria-label={ariaLabel}
                    id={buttonIconId}
                    aria-controls={this.openMenuDecisao ? ariaControls : undefined}
                    aria-haspopup="true"
                    aria-expanded={this.openMenuDecisao ? 'true' : undefined}
                    onClick={this.handleClickMenuDecisao}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id={ariaControls}
                    anchorEl={this.anchorElDecisao}
                    open={this.openMenuDecisao}
                    onClose={this.handleCloseMenuDecisao}
                    slotProps={{
                        list: {
                            'aria-labelledby': buttonIconId
                        }
                    }}
                >
                    <MenuItem onClick={this.handleClickDesconsiderarQuebraLinhasDecisao}>
                        <ListItemIcon>
                            {this.desconsiderarQuebrasLinhasDecisao ? (
                                <ToggleOnIcon
                                    style={{ fill: lightBlue[900] }}
                                    fontSize="large"
                                />
                            ) : (
                                <ToggleOffIcon fontSize="large" />
                            )}
                        </ListItemIcon>
                        <Typography sx={{ ml: 1 }}>Desconsiderar quebras de linhas</Typography>
                    </MenuItem>
                    <MenuItem onClick={() => this.handleClickCopiarTextoDecisao(this.textoDecisaoVoto)}>
                        <ListItemIcon>
                            <ContentCopyIcon fontSize="medium" />
                        </ListItemIcon>
                        <Typography sx={{ ml: 1 }}>Copiar decisão da minuta de voto</Typography>
                    </MenuItem>
                    <MenuItem onClick={() => this.handleClickCopiarTextoDecisao(this.textoDecisao)}>
                        <ListItemIcon>
                            <ContentCopyIcon fontSize="medium" />
                        </ListItemIcon>
                        <Typography sx={{ ml: 1 }}>Copiar decisão da planilha</Typography>
                    </MenuItem>
                </Menu>
            </>
        );
    }

    get renderMenuEmenta() {
        const tipoTexto = TIPO_TEXTO.EMENTA;
        const ariaLabel = 'configuracoes-'.concat(tipoTexto.id);
        const ariaControls = 'menu-'.concat(tipoTexto.id);
        const buttonIconId = 'button-'.concat(tipoTexto.id);

        return (
            <>
                <IconButton
                    aria-label={ariaLabel}
                    id={buttonIconId}
                    aria-controls={this.openMenuEmenta ? ariaControls : undefined}
                    aria-haspopup="true"
                    aria-expanded={this.openMenuEmenta ? 'true' : undefined}
                    onClick={this.handleClickMenuEmenta}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id={ariaControls}
                    anchorEl={this.anchorElEmenta}
                    open={this.openMenuEmenta}
                    onClose={this.handleCloseMenuEmenta}
                    slotProps={{
                        list: {
                            'aria-labelledby': buttonIconId
                        }
                    }}
                >
                    <MenuItem onClick={this.handleClickDesconsiderarQuebraLinhasEmenta}>
                        <ListItemIcon>
                            {this.desconsiderarQuebrasLinhasEmenta ? (
                                <ToggleOnIcon
                                    style={{ fill: lightBlue[900] }}
                                    fontSize="large"
                                />
                            ) : (
                                <ToggleOffIcon fontSize="large" />
                            )}
                        </ListItemIcon>
                        <Typography sx={{ ml: 1 }}>Desconsiderar quebras de linhas</Typography>
                    </MenuItem>
                    <MenuItem onClick={() => this.handleClickCopiarTextoEmenta(this.textoEmentaVoto)}>
                        <ListItemIcon>
                            <ContentCopyIcon fontSize="medium" />
                        </ListItemIcon>
                        <Typography sx={{ ml: 1 }}>Copiar ementa da minuta de voto</Typography>
                    </MenuItem>
                    <MenuItem onClick={() => this.handleClickCopiarTextoEmenta(this.textoEmenta)}>
                        <ListItemIcon>
                            <ContentCopyIcon fontSize="medium" />
                        </ListItemIcon>
                        <Typography sx={{ ml: 1 }}>Copiar ementa da planilha</Typography>
                    </MenuItem>
                </Menu>
            </>
        );
    }

    renderComparador(conteudoAntigo, conteudoNovo) {
        const textOnly = true;

        const compareStyles = {
            lineNumber: {
                cursor: 'default'
            },
            titleBlock: {
                fontWeight: 'bold',
                fontStyle: 'italic'
            }
        };

        return (
            <ReactDiffViewer
                oldValue={this.formatHTMLForDiff(conteudoAntigo, textOnly)}
                newValue={this.formatHTMLForDiff(conteudoNovo, textOnly)}
                splitView={true}
                compareMethod={DiffMethod.WORDS_WITH_SPACE}
                styles={compareStyles}
                leftTitle="Original (minuta de voto)"
                rightTitle="Alteração do gabinete para esta sessão (planilha)"
            />
        );
    }

    render() {
        return (
            <Dialog
                open={this.observableProps.open}
                onClose={this.observableProps.onClose}
                maxWidth="lg"
                style={{
                    minHeight: '600px'
                }}
            >
                <DialogTitle>Comparação de textos</DialogTitle>
                <DialogContent dividers={true}>{this.renderDialogContent()}</DialogContent>
                <DialogActions sx={{ mr: 3 }}>
                    <Button
                        onClick={this.observableProps.onClose}
                        color="primary"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default inject('stores')(observer(ComparadorEmentaDecisao));
